import { Trans, useLingui } from "@lingui/react/macro";

import { cn } from "@/shared/lib";

type MatchPlaceBadgeProps = {
  // Место по оценке Valve: 1 — MVP, 2 и 3; 0 — вне тройки; `null` — неизвестно.
  rank: number | null;
  className?: string;
};

// Пометка места игрока в матче (макет `design/prototype/MatchesMvp.dc.html`): MVP — золотая
// «таблетка» с короной, 2-е и 3-е место — контурная. Вне тройки и неизвестно — ничего.
export const MatchPlaceBadge = ({ rank, className }: MatchPlaceBadgeProps) => {
  const { t } = useLingui();
  if (rank === 1) {
    return (
      <span
        title={t`Match MVP by the game's rating`}
        className={cn(
          "inline-flex items-center gap-1 rounded-full bg-accent py-px pr-2 pl-1.5 text-[11px] font-bold tracking-[0.04em] text-accent-foreground",
          className,
        )}
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M3 8l4.5 4L12 5l4.5 7L21 8l-2 11H5L3 8z" />
        </svg>
        <Trans>MVP</Trans>
      </span>
    );
  }
  if (rank === 2 || rank === 3) {
    return (
      <span
        title={t`Second or third player of the match by the game's rating`}
        className={cn(
          "inline-flex items-center rounded-full border border-border-strong px-2 text-[11px] font-semibold text-accent",
          className,
        )}
      >
        {rank === 2 ? <Trans>2nd in match</Trans> : <Trans>3rd in match</Trans>}
      </span>
    );
  }
  return null;
};
